// The "CODE - Name" pair, rendered identically wherever a master-backed
// code is shown beside the name it stands for: CategorySelectCell's
// trigger (401060 - IT Hardware) and LineItemsEditor's Ship To trigger and
// option list (DEL001 - DelhiOne). Extracted to its own file rather than
// duplicated - the FieldError.jsx precedent (Item 4b, 2026-07-21) - so the
// two surfaces cannot drift into an unregistered mirror pair.
//
// NO UNMATCHED ARM LIVES HERE, DELIBERATELY, and this is the load-bearing
// part of the contract: THIS COMPONENT IS NEVER ASKED TO RENDER A NAME IT
// DOES NOT HAVE. The two callers resolve an unknown code by DIFFERENT
// rules, so the decision stays with them:
//   - category renders an unknown code as "(update required)" in amber
//   - a line's ship-to renders it as the CODE ALONE, because F16
//     (2026-08-18) ruled the "not in current list" marker is a LIST
//     annotation while the trigger is the VALUE
// Those are two rules, not one rule written twice. Folding either into
// this component would make it a third rule that has to agree with both.
// A caller that passes a missing name would render "CODE - " with an empty
// tail, which is worse than the code by itself - so callers guard, and
// their tests pin the guard (LineItemsEditor.shipToUnmatched.test.jsx).
const CodeNameLabel = ({ code, name }) => (
  <span className="truncate text-xs">
    <span className="font-mono">{code}</span>
    <span className="text-zinc-400 mx-1">-</span>
    <span>{name}</span>
  </span>
);

export default CodeNameLabel;
